import DB from "./dbclass";

export const db = new DB();
